import { Component, OnInit } from "@angular/core";
import { LoaderService } from "./services/loader.service";
import { Observable } from "rxjs";
@Component({
  selector: "loader",
  template: `
    <div *ngIf="isLoading | async" class="loaderMask">
    <img src="../assets/img/loader.gif" width="100" style=" display: block;
    margin-left: auto;
    margin-right: auto;
    width: 5%;">
    </div>
  `,
  styles: [
    ".loaderMask{position: absolute; height: 100%; width: 100%; z-index: 9999; background-color: rgba(100, 100, 100, 0.3);display: flex; align-items: center; justify-content: center; font-size: 24px;}"
  ]
})
export class LoaderComponent implements OnInit {
  isLoading: Observable<boolean>;

  constructor(private loaderService: LoaderService) {
    this.isLoading = this.loaderService.loading$;
  }

  ngOnInit(): void {}
}
